// extracted by mini-css-extract-plugin
module.exports = {"containerBreadcrum":"styles_containerBreadcrum__2gpEu"};